import { BrowserRouter, Route, Routes } from "react-router-dom";
import CarRequestPage from "src/pages/car-request";
import NotFound from "src/shared/components/not-found";
import PreBookingPage from "src/pages/pre-booking";
import FeedBackPage from "src/pages/feedback";
import KAFDPreBookingPage from "src/pages/kafd-pre-booking";
import ExtendBookingPage from "src/pages/kafd-pre-booking/extend-booking-page";
import PolicyUsage from "src/pages/policy-usage";
import LoadingPage from "src/pages/loading-page";
import KafdAllLocationsMap from "src/pages/kafd-locations";
import CarWashRequestPage from "src/pages/car-wash-request";
import JycCampaign from "src/pages/jyc-campaign";
import DownloadCustomerApp from "src/pages/download-customer-app";

function AllRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<CarRequestPage />} path="/request-car/:id" />
        <Route element={<PreBookingPage />} path="/pre-booking/:locationId" />
        <Route element={<FeedBackPage />} path="/feedback/:id" />
        <Route element={<KAFDPreBookingPage />} path="/kafd-pre-booking" />
        <Route element={<KAFDPreBookingPage />} path="/kafd-pre-booking/:id" />
        <Route
          element={<ExtendBookingPage />}
          path="/kafd-extend-booking/:id"
        />
        <Route element={<KafdAllLocationsMap />} path="/kafd-locations" />
        <Route element={<CarWashRequestPage />} path="/car-wash/:locationId" />
        <Route
          element={<CarWashRequestPage />}
          path="/car-wash/:locationId/:id"
        />
        <Route element={<JycCampaign />} path="/jyc-campaign" />
        <Route element={<DownloadCustomerApp />} path="/download" />
        <Route element={<LoadingPage />} path="/loading" />
        <Route element={<PolicyUsage />} path="/policy" />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default AllRoutes;
